const PATTERNS = [
    /youtu\.be\/([A-Za-z0-9_-]{11})/,
    /youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/|v\/)([A-Za-z0-9_-]{11})/,
    /^([A-Za-z0-9_-]{11})$/
]

export const youtubeId = (url: string | null | undefined): string | null => {
    if (!url) return null

    const value = url.trim()

    for (const pattern of PATTERNS) {
        const match = value.match(pattern)

        if (match) return match[1]
    }

    return null
}

export const youtubeThumbnail = (id: string): string => `https://i.ytimg.com/vi/${id}/hqdefault.jpg`

export const youtubeEmbedUrl = (id: string, autoplay = true): string =>
    `https://www.youtube-nocookie.com/embed/${id}?${autoplay ? 'autoplay=1&' : ''}rel=0&modestbranding=1&playsinline=1`

export const youtubeWatchUrl = (id: string): string => `https://www.youtube.com/watch?v=${id}`
